import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { setActiveMeetingMemberListActiveStatus } from 'flow/actions/meeting-actions';
import { selectActiveMeetingMemberListActiveStatus } from 'flow/selectors/meeting-selectors';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';

// The headless menu closes itself when an item is activated, so items only
// need to fire their action.
const MenuItemToggleMembersList = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const membersListActive = useAppSelector(
        selectActiveMeetingMemberListActiveStatus,
    );

    const onClick = useCallback(() => {
        dispatch(setActiveMeetingMemberListActiveStatus(!membersListActive));
    }, [dispatch, membersListActive]);

    return (
        <MenuItem
            onClick={onClick}
            className="!bg-gray-800 !text-white hover:!bg-gray-700"
        >
            <Icon iconKey="group" className="me-1.5" />
            <div>{i18next.t('videoconference.controlpanel.participants')}</div>
        </MenuItem>
    );
};

export default MenuItemToggleMembersList;
